import moment from 'moment';

const datetime = {
  formatTimestamp: (value, format = 'LLL') => moment(value).format(format),
};

const strings = {
  capitalise: value => String(value).charAt(0).toUpperCase() + String(value).slice(1),
  toCaps: value => String(value).toUpperCase(),
};

const numbers = {
  round: (value, precision = 2) => parseFloat(value).toFixed(precision),
};

export default {
  datetime,

  strings,

  numbers,
};
